import { ApiResps } from 'providers';
import { OperationType, StatusType } from '../StatusCard';

export type Operation = NonNullable<ApiResps['/remote-control/get-machine-info']['OPERATION']>;

export interface EconomyModeBarProps {
  checked: boolean;
  loading: boolean;
  openEconomyModeOffModalByManualMode: boolean;
  onClickCheck: () => void;
  onCloseEconomyModeOff: () => void;
}

export interface OperationButtonProps {
  readonly onClickModality: () => void;
  readonly operation: 'fan' | 'cool';
  readonly currentOperation: Operation;
  readonly disabled: boolean;
  readonly loading?: boolean;
}

export interface PowerButtonProps {
  readonly onClickModality: () => void;
  readonly loading?: boolean;
}

export type State = 'allow' | 'onlyfan' | 'forbid' | 'disabling' | 'eco' | 'enabling' | 'thermostat' | 'cool';

export type StatusCardOptions = {
  connection: boolean;
  status: StatusType | undefined;
  operation: OperationType | undefined;
  healthStatus: HealthStatus | undefined;
  healthVisible: boolean;
}

export enum HealthStatus {
  NO_ALERT = 'NO_ALERT',
  ALERT = 'ALERT',
  INOPERATIVE = 'INOPERATIVE',
}

export enum CesEvent {
  DISABLE_ECONOMY_MODE = 'desativar_modo_economia',
  ENABLE_ECONOMY_MODE = 'ligar_modo_economia',
  CHANGE_TEMPERATURE = 'alterar_temperatura',
  CHANGE_MODE = 'mudar_modo',
  TURN_ON_DEVICE = 'ligar_dispositivo',
  TURN_OFF_DEVICE = 'desligar_dispositivo',
}

export type EnvironmentItem = {
  id: number,
  name: string,
  dutCode: string,
  selfReference: boolean,
  returnTemperatureField?: string
}

/** Ambiente que tem de onde ler temperatura — a API só preenche o campo quando existe fonte. */
export type EnvironmentWithTemperature = EnvironmentItem & { returnTemperatureField: string };
